import { useCandidateUrl } from 'domain/shared/candidate';
import { useEntityUrl } from 'framework/routing';

const CANDIDATE_OFFER_ID = 'candidateOfferId';
const PATH = '/offers';

export const useCandidateOfferUrl = () => {
  const { getSingleEntityUrl } = useCandidateUrl();
  const candidateLink = getSingleEntityUrl();

  return useEntityUrl({
    baseLink: `${candidateLink}${PATH}`,
    idSource: CANDIDATE_OFFER_ID,
  });
};
